<template>
<!-- eslint-disable max-len -->
<edit-page
  name="Role"
  model-name="role"
  param="roleId"
  page-prefix="/blade/roles"
  :create="createRole"
  :fetch="getRole"
  :update="updateRole"
  :remove="deleteRole"
  :enum-names="['variants']"
  :stub="role"
  :validator="validator"
  :utils="utils">
<template slot-scope="{ model: role, enums: { variants }, validator }">
  <text-input label v-model.trim="role.name" :validator="validator.name" required autofocus>Name</text-input>

  <text-input label v-model.trim="role.title" :validator="validator.title" required>Title</text-input>
  <voice-line-input
    :text="role.title"
    :data-object="role"
    field-name="titleVoiceLine"
  ></voice-line-input>

  <text-input label v-model.trim="role.description" textarea>Description</text-input>
  <voice-line-input
    :text="role.description"
    :data-object="role"
    field-name="descriptionVoiceLine"
  ></voice-line-input>

  <img
    v-if="role.image"
    class="form-image-background role-edit-image"
    :src="resolveAssetPath(role.image, 'images')"
  />
  <asset-select-input label v-model="role.image" legacy-manifest-path="images">
    Image
  </asset-select-input>

  <img
    v-if="role.background"
    class="form-image-background role-edit-image"
    :src="resolveAssetPath(role.background, 'backgrounds')"
  />
  <asset-select-input label v-model="role.background" legacy-manifest-path="backgrounds">
    Background
  </asset-select-input>

  <img
    v-if="role.backgroundBanner"
    class="form-image-background role-edit-image"
    :src="resolveAssetPath(role.backgroundBanner, 'backgrounds')"
  />
  <asset-select-input label v-model="role.backgroundBanner" legacy-manifest-path="backgrounds">
    Background Banner
  </asset-select-input>

  <select-input
    label
    v-model="role.playerVariant"
    :options="variants"
  >
    Player Variant
  </select-input>
</template>
</edit-page>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import EditPage from '../../ui/pages/EditPage';

import AssetSelectInput from '../../ui/inputs/AssetSelectInput';
import SelectInput from '../../ui/inputs/SelectInput';
import TextInput from '../../ui/inputs/TextInput';
import VoiceLineInput from '../../ui/inputs/VoiceLineInput';

export default {
  components: {
    EditPage,
    AssetSelectInput,
    VoiceLineInput,
    SelectInput,
    TextInput
  },
  data() {
    return {
      utils: {
      },
      role: {
        _id: '',
        name: '',
        title: '',
        description: '',
        image: '',
        background: '',
        backgroundBanner: '',
        playerVariant: ''
      },
      validator: {
        name: { required },
        title: { required }
      }
    };
  },
  methods: {
    ...mapActions([
      'getRole',
      'createRole',
      'updateRole',
      'deleteRole'
    ])
  }
};
</script>

<style lang="scss" scoped>
.role-edit-image {
  margin: 18px 0 -9px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/RoleEdit.vue